var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.accountsInfo)?_c('carousel',{ref:"owl",attrs:{"autoplay":true,"responsive":{
      1200:{items:4,nav:false},
      600:{items:2,nav:true}
    },"nav":false,"items":1}},_vm._l((_vm.statistic),function(info,key){return _c('div',{key:key,staticClass:"w-full cursor-pointer inline-block p-4",on:{"click":function($event){return _vm.selectAccount({
        ...info,
        accountNumber: info.account_number,
      })}}},[_c('StatisticsCardLine',{class:{'bg-selected': (info.id === _vm.selected)},attrs:{"icon":'HomeIcon',"statistic":info.statistic,"statistic-title":info.account_number,"chart-data":info.chartData,"hide-chart":_vm.hideChart,"name":info.name}})],1)}),0):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }